import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Box, Container } from "@material-ui/core";
import CustomerListResults from "src/components/StockTransfer/CustomerListResults";
import CustomerListToolbar from "src/components/StockTransfer/CustomerListToolbar";
import { URL } from "../utils/factory";
import InvoiceDetailToolbar from "src/components/InvoiceDetailPage/InvoiceDetailToolbar";
import InvoiceDetailResult from "src/components/InvoiceDetailPage/InvoiceDetailResult";

const axios = require("axios");

const moment = require("moment");

const InvoiceDetailPage = () => {
  const [invoicelist, setInvoicelList] = useState([]);
  const [invoicelistOld, setInvoicelListOld] = useState([]);
  const [changeflag, setChangeFlag] = useState(false);
  const [bookedfilter, setBookedfilter] = useState(5);
  const [statusfilter, setStatusfilter] = useState(0);
  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [loaderflag, setLoderFlag] = useState(false);
  const [exportflag, setExportFlag] = useState(true);
  const [exportflagver, setExportFlagVer2] = useState(true);
  const [exportflagverCSV, setExportFlagVerCsv] = useState(true);

  const [invoicelistexport, setInvoicelListExport] = useState([]);
  const [invoicelistexportver, setInvoicelListExportVer] = useState([]);
  const [invoicelistexportcsv, setInvoicelListExportCsv] = useState([]);

  const [searchtext, setSearchText] = useState("");

  const statusList = [
    {
      id: 0,
      label: "All",
    },
    {
      id: 1,
      label: "Unconfirmed",
    },
    {
      id: 2,
      label: "Confirmed/Unapproved",
    },
    {
      id: 3,
      label: "Approved",
    },
  ];

  const deliverTypeList = [
    {
      id: 5,
      label: "All",
    },
    {
      id: 1,
      label: "Standard Delivery",
    },
    {
      id: 2,
      label: "Stock Transfer",
    },
    {
      id: 3,
      label: "Deluxe",
    },
    {
      id: 4,
      label: "Extra Charges",
    },
    {
      id: 6,
      label: "Sales Return",
    },
    {
      id: 7,
      label: "Service Call",
    },
    {
      id: 8,
      label: "Labour Hire",
    },
    {
      id: 9,
      label: "Truck Booking(4T/6T/10T/van)",
    },
    {
      id: 10,
      label: "Other Booking",
    },
    {
      id: 11,
      label: "Cancellation",
    },
    {
      id: 12,
      label: "Tip Run",
    },
    {
      id: 13,
      label: "Line Haul Fee",
    },
  ];

  const handleExportData = () => {
    setLoderFlag(true);
    const clientid = localStorage.getItem("tranuserid");
    try {
      axios
        .post(`${URL}trans_loaditems_stocktransfer`, {
          userid: clientid,
          qtype: "8",
          searchtext: bookedfilter,
          fdate: fromdate,
          tdate: todate,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoicelListExport(userdata);
            setExportFlag(false);
            setLoderFlag(false);
          } else {
            setInvoicelListExport([]);
            setExportFlag(false);
            setLoderFlag(false);
          }
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewInvoiceSearchFilter = async (eta, inv) => {
    const value = await localStorage.getItem("InvoiceSno");
    const clientid = localStorage.getItem("tranuserid");

    setChangeFlag(true);
    setLoderFlag(true);
    setInvoicelList([]);
    setInvoicelListOld([]);
    axios
      .post(`${URL}Invoicet`, {
        settlemnet: value && value,
        qtype: "8",
        Fromdate: "",
        Todate: "",
        status: eta !== undefined ? eta : "",
        InvoiceNo: "",
        invoiceswith: inv !== undefined ? inv : "",
        supplier: clientid,
      })
      .then((response) => {
        if (response.data.d.length > 0) {
          // eslint-disable-next-line no-eval
          const userdata = eval(response.data.d);
          setInvoicelList(userdata);
          setInvoicelListOld(userdata);
          setLoderFlag(false);
        } else {
          setInvoicelList([]);
          setInvoicelListOld([]);
          setLoderFlag(false);
        }
      })
      .catch((error) => {
        console.log("API error in sending file :::::", error);
      });
  };

  const handleViewInvoice = async (inv) => {
    const value = await localStorage.getItem("InvoiceSno");
    const clientid = localStorage.getItem("tranuserid");
    setChangeFlag(true);
    setLoderFlag(true);
    setInvoicelList([]);
    setInvoicelListOld([]);
    axios
      .post(`${URL}Invoicet`, {
        settlemnet: value && value,
        qtype: "8",
        Fromdate: "",
        Todate: "",
        status: inv ? inv : "",
        InvoiceNo: "",
        invoiceswith: "",
        supplier: clientid,
      })
      .then((response) => {
        if (response.data.d.length > 0) {
          // eslint-disable-next-line no-eval
          const userdata = eval(response.data.d);

          setInvoicelList(userdata);
          setInvoicelListOld(userdata);
          setLoderFlag(false);
        } else {
          setInvoicelList([]);
          setInvoicelListOld([]);
          setLoderFlag(false);
        }
      })
      .catch((error) => {
        console.log("API error in sending file :::::", error);
      });
  };

  const handlebetaversiontwo = () => {
    setLoderFlag(true);
    const clientid = localStorage.getItem("tranuserid");
    try {
      axios
        .post(`${URL}stocktranexportbetav2`, {
          userid: clientid,
          qtype: "1",
          status: bookedfilter,
          invoiceno: searchtext,
          fdate: fromdate,
          tdate: todate,
          invstatus: statusfilter,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoicelListExportVer(userdata);
            setExportFlagVer2(false);
            setLoderFlag(false);
          } else {
            setInvoicelListExportVer([]);
            setExportFlagVer2(false);
            setLoderFlag(false);
          }
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handelCsvButon = () => {
    setLoderFlag(true);
    const clientid = localStorage.getItem("tranuserid");
    try {
      axios
        .post(`${URL}tranexportcsv`, {
          userid: clientid,
          qtype: "1",
          status: bookedfilter,
          invoiceno: searchtext,
          fdate: fromdate,
          tdate: todate,
          invstatus: statusfilter,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoicelListExportCsv(userdata);
            setExportFlagVerCsv(false);
            setLoderFlag(false);
          } else {
            setInvoicelListExportCsv([]);
            setExportFlagVerCsv(false);
            setLoderFlag(false);
          }
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleResetFilter = () => {
    setBookedfilter(5);
    setStatusfilter(0);
  };

  const handleDate = async (fdate, sdate) => {
    const value = await localStorage.getItem("InvoiceSno");

    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    let fdateformat = "";
    let sdateformat = "";
    fdateformat = new Date(fdate);
    sdateformat = new Date(sdate);
    fdateformat = moment(fdateformat).format("YYYY-MM-DD");
    sdateformat = moment(sdateformat).format("YYYY-MM-DD");

    setFromdate(fdateformat);
    setTodate(sdateformat);
    handleResetFilter();

    if (fdateformat !== "" && sdateformat !== "") {
      setChangeFlag(true);
      setLoderFlag(true);
      setInvoicelList([]);
      setInvoicelListOld([]);
      const clientid = localStorage.getItem("tranuserid");
      try {
        axios
          .post(`${URL}Invoicet`, {
            settlemnet: value,
            qtype: "8",
            Fromdate: fdateformat,
            Todate: sdateformat,
            status: statusfilter,
            InvoiceNo: "",
            invoiceswith: bookedfilter,
            supplier: clientid,
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
            },
          })
          .then((response) => {
            if (response.data.d.length > 0) {
              const userdata = eval(response.data.d);
              setInvoicelList(userdata);
              setInvoicelListOld(userdata);
              setLoderFlag(false);
            } else {
              setInvoicelList([]);
              setInvoicelListOld([]);
              setLoderFlag(false);
            }
          })
          .catch((error) => {
            console.log("API error", error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handlesearch = async (e, type) => {
    const value = await localStorage.getItem("InvoiceSno");

    if (e.code === "Enter" || type === "2") {
      if (type === "2" && e === "") {
        handleDate(fromdate, todate);
        return;
      }
      if (type === "1" && e.target.value === "") return;
      setChangeFlag(true);
      setExportFlagVer2(true);
      setExportFlagVerCsv(true);
      setLoderFlag(true);
      handleResetFilter();
      // if (type === '1') handleExportData(fromdate, todate, e.target.value);
      // else if (type === '2') handleExportData(fromdate, todate, e);
      // console.log('Custmer Search::::::::', e.target.value);
      const clientid = localStorage.getItem("tranuserid");
      try {
        setInvoicelList([]);
        setInvoicelListOld([]);

        axios
          .post(`${URL}Invoicet`, {
            settlemnet: value && value,
            qtype: "8",
            InvoiceNo: type === "1" ? e.target.value : e,
            Fromdate: "",
            Todate: "",
            status: "",
            invoiceswith: "",
            supplier: clientid,
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
            },
          })
          .then((response) => {
            if (response.data.d.length > 0) {
              // eslint-disable-next-line no-eval
              const userdata = eval(response.data.d);
              setInvoicelList(userdata);
              setInvoicelListOld(userdata);
            } else {
              setInvoicelList([]);
              setInvoicelListOld([]);
            }
            setLoderFlag(false);
          })
          .catch((error) => {
            console.log("API error", error);
            setLoderFlag(false);
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getchilddata = (data) => {
    setInvoicelList(data);
    setInvoicelListOld(data);
  };

  const [stateData, setStateData] = useState();

  const handleChangeSelectSearch = (invoicestatus, bookedstatsus) => {
    console.log("************************13", invoicestatus, bookedstatsus);

    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    let data = invoicelistOld;

    let invstatus = statusList.filter((a) => a.id == invoicestatus);
    console.log("************************14", invstatus);

    setStateData(invoicestatus);
    invstatus = invstatus[0].id;

    let deltypelist = deliverTypeList.filter((a) => a.id == bookedstatsus);
    deltypelist = deltypelist[0].id;

    handleViewInvoiceSearchFilter(invstatus, deltypelist);
  };

  const handleChangeselect = (event) => {
    console.log("************************12", event.target.value);
    handleChangeSelectSearch(statusfilter, event.target.value);
    setBookedfilter(event.target.value);
  };

  const handleChangeselected = (event) => {
    handleChangeSelectSearch(event.target.value, bookedfilter);
    setStatusfilter(event.target.value);
  };

  useEffect(async () => {
    await handleViewInvoice();
  }, [localStorage.getItem("InvoiceSno")]);

  useEffect(() => {
    let date = localStorage.getItem("settlementDate");
    // let dateOne = date.split('-')[0]
    // let dateTwo = date.split('-')[1]
    let prevdateold = new Date();
    let currentdate = new Date();
    prevdateold = moment(prevdateold).format("MM/DD/YYYY");
    setFromdate(prevdateold);
    currentdate = moment(currentdate).format("MM/DD/YYYY");
    setTodate(currentdate);
  }, []);

  const handleSearchText = (inv) => {
    setSearchText(inv);
  };

  return (
    <>
      <Helmet>
        <title>Invoice List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <InvoiceDetailToolbar
            clickToSearch={handlesearch}
            handleSearchText={handleSearchText}
            datesearch={handleDate}
            customers={invoicelist && invoicelist}
            handleChangeselect={handleChangeselect}
            handleChangeselected={handleChangeselected}
            selectvalue={bookedfilter}
            selectvalues={statusfilter}
            fromdate={fromdate}
            todate={todate}
            handleresetfilter={handleResetFilter}
          />
          <Box sx={{ pt: 3 }}>
            <InvoiceDetailResult
              customers={invoicelist && invoicelist}
              flagstatus={changeflag}
              getchilddata={getchilddata}
              fromdate={fromdate}
              todate={todate}
              datesearch={handleDate}
              loaderflag={loaderflag}
              exportlist={invoicelistexport}
              handleExportGrid={handleExportData}
              exportflag={exportflag}
              handleExportGridTwo={handlebetaversiontwo}
              exportlisttwo={invoicelistexportver}
              exportflagver={exportflagver}
              exportflagverCSV={exportflagverCSV}
              handelCsvButon={handelCsvButon}
              invoicelistexportcsv={invoicelistexportcsv}
              handleViewInvoice={handleViewInvoice}
              stateData={stateData}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default InvoiceDetailPage;
